export default {
  screens: [
    {
      type: 'intro',
      title: 'L’art du bijou transformable',
      content:
        'Promenades Impériales, un hommage à la Russie et à la beauté de l’hiver sibérien. <br/>Un chef-d’œuvre illustrant l’une des virtuosités Chaumet : l’art de créer des pièces transformables.<br> Le collier aux lignes pures illuminées par les saphirs Padparadscha se prête à divers portés et se transforme aussi en broche.',
      idYt: 'FAAhbyqO57o',
      videoCover: 'world/transformer/video.jpg',
      desktop: {
        cover: 'world/transformer/cover-1.jpg',
        introRight: 'world/transformer/introRight.jpg'
      },
      mobile: {
        cover: 'world/transformer/mobile-cover-1.jpg',
        contentStyle: { width: '92%' },
        coverStyle: {
          width: '34%',
          height: 'auto',
          top: '31.5vh',
          bottom: 'inherit',
          right: '-10px',
          left: 'inherit',
          position: 'absolute'
        },
        introRight: 'world/transformer/introRight.jpg'
      },
      isCover: true
    },
    {
      type: 'memento',
      img: 'world/transformer/memento.jpg',
      imgRight: 'world/transformer/mementoRight.jpg',
      mobile: {
        contentStyle: {
          width: '77.5%',
          left: '22.5%'
        }
      },
      content:
        'Cette maîtrise virtuose se retrouve dans la collection de Haute Joaillerie Trésors d’Afrique : la broche Fourmisse se transforme en une paire de boucles d’oreilles.'
    },
    {
      type: 'column',
      middleImg: 'world/transformer/columnMiddle.jpg',
      content:
        'Habité d’émeraudes d’exception, ce diadème nous vient des Leuchtenberg, descendants de Joséphine.<br><br>Il donne vie à un jardin en mouvement, cher à Chaumet. Un pas et la trembleuse fait osciller les fleurs, un tour de main et chacune se transforme en broche.'
    }
  ],
  mobile: {
    mainContentStyle: { paddingBottom: '20px' }
  }
}



// WEBPACK FOOTER //
// ./src/locales/fr/worlds/transformer.js